// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7932061e]:export {\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n  subMenuActiveText: #f4f4f5;\n  menuBg: #304156;\n  menuHover: #263445;\n  subMenuBg: #1f2d3d;\n  subMenuHover: #001528;\n  sideBarWidth: 210px;\n}\n.btn_area[data-v-7932061e] {\n  text-align: right;\n}\n.main_table[data-v-7932061e] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}", ""]);
// Exports
module.exports = exports;
